export enum State {
  FINALYSETTLED = 'Finally settled',
  PENDING = 'Pending',
  DRAFT = 'Draft',
  SETTLED = 'Settled',
  PENDING_OVERDUE = 'Pending & Overdue',
  ADJOURNED = 'Adjourned'
}
